import { useTranslation } from 'react-i18next';
import SimpleMultiSelect from '~/components/inputs/Select/SimpleMultiSelect';
import { BookkeepingAdjustmentGroup } from '~/types/general-bookkeeping';
import styles from './BookkeepingAdjustmentGroupFilter.module.scss';

interface BookkeepingAdjustmentGroupFilterProps {
  value: BookkeepingAdjustmentGroup[];
  onChange: (value: BookkeepingAdjustmentGroup[]) => void;
}

const options = [
  { labelKey: 'ratei', value: BookkeepingAdjustmentGroup.Ratei },
  { labelKey: 'risconti', value: BookkeepingAdjustmentGroup.Risconti },
  { labelKey: 'ammortamenti', value: BookkeepingAdjustmentGroup.Ammortamenti },
  { labelKey: 'fatture_da_emettere_ricevere', value: BookkeepingAdjustmentGroup.FattureDaEmettereRicevere },
] as const;

const BookkeepingAdjustmentGroupFilter = ({ value, onChange }: BookkeepingAdjustmentGroupFilterProps) => {
  const { t } = useTranslation('bookkeeping', {
    keyPrefix: 'general_bookkeeping.cash_book.filters.adjustment_groups',
  });

  return (
    <SimpleMultiSelect
      label={t('label')}
      placeholder={t('placeholder')}
      name="adjustmentGroups"
      clearable
      value={value}
      onChange={(val) => onChange(val as BookkeepingAdjustmentGroup[])}
      options={options.map((o) => ({ label: t(`options.${o.labelKey}`), value: o.value }))}
      renderMultipleSelectionValue={(selected) => t('multiple_value', { count: selected.length })}
      className={styles.adjustmentFilter}
    />
  );
};

export default BookkeepingAdjustmentGroupFilter;
